export const SET_COURSE_DETAILS = 'SET_COURSE_DETAILS'
export const SET_STEP_PROGRESS = 'SET_STEP_PROGRESS'
